import React from "react"
import GenericForm from "../GenericForm";
import StringInput from "../../formElements/StringInput";

function ServiceCaseActionForm(props) {

    const formContent = (data, update) => (
        <>
            <StringInput name={'Nazov'} label={'Názov'} value={data.Nazov} onChange={update}/>
        </>
    )

    return (
        <GenericForm label="Druh Činnosti"
                     labelNew="Pridať Druh Činnosti"
                     baseUrl='/service_case/service_cases_actions/'
                     formContent={formContent}/>
    )
}

export default ServiceCaseActionForm
